// extracted by mini-css-extract-plugin
export default {"container":"TnSnapboxOtpModal_container__K1RZU"};